import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import Button from 'components/shared/Button'
import Checkbox from 'components/shared/Checkbox'
import Input from 'components/shared/Input'
import { SESSION_TYPE_MARCH_PROMO } from 'constants/app'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { selfcareFirstStep } from 'routes/basenames'
import { useGuestLoginMutation } from 'store/api-slice/hooks'
import { useApp } from 'store/steps'
import { Col, Row } from 'styled-bootstrap-grid'

const TemporarySelfcareModal = () => {
    const { language } = useApp()
    const [inputEmail, setEmail] = useState('')
    const [inputPaymentNumber, setPaymentNumber] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [isMarchPromoSession, setIsMarchPromoSession] = useState(false)

    const [loginToSelfcare] = useGuestLoginMutation()

    const [searchParams] = useSearchParams()
    const paramEmail = searchParams.get('email')
    const paramPaymentNumber = searchParams.get('paymentNumber')

    const handleSubmit = (email: string, paymentNumber: string) => {
        setIsLoading(true)
        loginToSelfcare({
            _locale: language,
            createSelfcareSessionCommand: {
                type: isMarchPromoSession
                    ? SESSION_TYPE_MARCH_PROMO
                    : undefined,
                email,
                paymentNumber,
            },
        }).then(() => {
            setIsLoading(false)
            window.location.href = selfcareFirstStep
        })
    }

    useEffect(() => {
        if (!paramEmail || !paramPaymentNumber) return
        setEmail(paramEmail)
        setPaymentNumber(paramPaymentNumber)
        handleSubmit(paramEmail, paramPaymentNumber)
    }, [])

    return (
        <Row>
            <Col lg={6}>
                <Box gap={24}>
                    <Input
                        id="paymentNumber"
                        type="text"
                        label="Payment Number"
                        value={inputPaymentNumber}
                        onChange={setPaymentNumber}
                        hasNoMaxWidth={true}
                        testId="selfcare-modal-field-payment-number"
                    />
                    <Input
                        id="email"
                        type="email"
                        label="Email"
                        value={inputEmail}
                        onChange={setEmail}
                        hasNoMaxWidth={true}
                        testId="selfcare-modal-field-email"
                    />
                    <Checkbox
                        isChecked={isMarchPromoSession}
                        setIsChecked={() =>
                            setIsMarchPromoSession((prev) => !prev)
                        }
                    >
                        <Text variant="bodySmall" color="grayscale_900">
                            March Promo Session
                        </Text>
                    </Checkbox>
                    <Button
                        onClick={() =>
                            handleSubmit(inputEmail, inputPaymentNumber)
                        }
                        isLoading={isLoading}
                        testId="selfcare-modal-button-proceed"
                    >
                        Go to selfcare
                    </Button>
                </Box>
            </Col>
        </Row>
    )
}

export default TemporarySelfcareModal
